/**CYBERPNEUMA-SOLUTIONS */
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { LoadingController } from '@ionic/angular';
import swal from 'sweetalert'
import { CorreoService } from './correo.service';
import PouchDB from 'pouchdb';
import { SeedsService } from './seeds.service';
import { WifiService } from './wifi.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public isOnline:boolean
  constructor(
    private loadingController:LoadingController,
    private auth:AngularFireAuth,
    private db:AngularFirestore,
    public networkService:WifiService,
    public seedService:SeedsService,
    private router:Router,
    private correo:CorreoService) { }


  /**
   * A function that allows you to access the login of the application, it is a function that is called
  
   * @param email - The email address of the user to create.
   * @param password - The user's password.
   */
  async accesoLogin(email,password){
    const loading = await this.loadingController.create({
      message: 'Cargando, Espere...',
      spinner: 'circles'
    });
    try{
      loading.present()
      this.networkService.isOnline().subscribe((online) => {
        this.isOnline = online;
        if (online) {
          this.auth.auth.signInWithEmailAndPassword(email,password).then(e=>{
            if(e.user.uid){
              this.db.collection('usuarios').doc(e.user.uid).get().subscribe(y=>{
                if(y.data()['role']=='4'){
                  if(y.data()['estado']=='pasante'){
                  
                      this.db.collection('usuarios').doc(y.data()['proveedor']).get().subscribe(j=>{
                        if(j.data()['estado_pago']==""){
                          swal("Falta de Pago de mes, de parte de distribuidor","Lo sentimos,cuenta bloqueada","warning")
                          loading.dismiss()
                        }
                      })
    
                    
                  }else{
                    if((y.data()['estado']=='validado')){
                      let obj={
                        role:y.data()['role'],
                        proveedor:y.data()['proveedor']
                      }
                      swal("Bienvenido","Cuenta Correcta y Valida","success")
                      this.estadoPagosRuteroDistri()
                      loading.dismiss()
                      this.registroBDlocal(obj)
                      
                    }
                  }
                }else{
                  if(y.data()['role']=='3'){
                    swal("Bienvenido","Cuenta Correcta","success")
                    let obj={
                      role:y.data()['role'],
                      proveedor:''
                    }
                    this.registroBDlocal(obj)
                    loading.dismiss()
                  }else{
                    swal("Bienvenido","Cuenta Correcta","success")
                    this.router.navigate(['/tabs/dashboard'])
                    loading.dismiss()
                  }
                 
    
                }
              
              })
            
            }
        
           }).catch(e=>{
          console.log(e)
            if(e.code=='auth/wrong-password'){
              swal("Contraseña Incorrecta","Porfavor Verifique Su contraseña","error")
              loading.dismiss()
    
            }else{
              if(e.code=='auth/too-many-requests'){
                swal("Acceso Bloqueado","Se ha bloqueado por seguridad, unos minutos el acceso a su cuenta,por tantos intentos invalidos de contraseña","error")
                loading.dismiss()
    
              }
            }
    
            if(e.code=='auth/user-not-found'){
              swal("Cuenta inexistente","Esta cuenta no existe ","error")
              loading.dismiss()
    
            }
            if(e.code=='auth/network-request-failed'){
              swal("Error ","No presenta Buena Señal de Internet ","error")
              loading.dismiss()
    
            }
            if(e.code=='auth/invalid-email'){
              swal("Error ","Formato de Correo Incorrecto ","error")
              loading.dismiss()
            }
           })
        } else {
          swal('Error','Problemas con conexion a internet','warning')
          loading.dismiss()
        }
      });
    
    }catch(e){
      window.location.reload()
    }
   
  }
 /**
  * It takes an email as a parameter, and then it sends a password reset email to that email
  * @param email - The email address of the user.
  */
  public resetPass(email){
  
      this.auth.auth.sendPasswordResetEmail(email).then(()=>{
        swal("Correcto","Se ha enviado un enlace a su correo para poder reestablecer la contraseña","success")
        this.router.navigateByUrl('/')

      }).catch(e=>{
        alert(e)
      })
    
    
  }
/**
 * It checks if the user is logged in, then it checks if the user has paid the monthly maintenance fee,
 * if not, it logs the user out and sends an email to the user's provider
 */

  public estadoPagosRuteroDistri()
    {
      this.auth.auth.onAuthStateChanged(o=>{
        this.datosPefilSesion(o.uid).subscribe(l=>{
        this.db.collection('usuarios',ref=>ref.where('role','==','3')).doc(l.data()['proveedor']).get().subscribe(l=>{
          if(l.data()['codigo_mantenimiento']==0){
            swal('Error Lo sentimos, de parte de tú proveedor asociado no hemos recibido el pago de mantemiento de este mes','','warning').then(()=>{
              this.correo.enviarCorreoExigirPago(l.data()['uid'])
              this.auth.auth.signOut()
            })
          }
          
        })
      })
    })
  }

 public  registroBDlocal(obj){
  this.auth.auth.onAuthStateChanged(f=>{
    if(obj.role=='3'){
      this.seedService.registroPuntosBaseLocal(f.uid).then(()=>{
        this.router.navigate(['/tabs/dashboard'])
      })
    }else{
      this.seedService.registroPuntosBaseLocal(obj.proveedor).then(()=>{
        this.router.navigate(['/tabs/dashboard'])
      })  

    }
    
   })
 }

  public datosPefil(){
    return  this.db.collection('usuarios')
  }

 /**
  * It returns the data of the user who is logged in.
  * @param u - user id
  */
  public datosPefilSesion(u){
    return  this.db.collection('usuarios').doc(u).get()
  }

  public datosPefilCouner(u){
    return  this.db.collection('usuarios').doc(u).snapshotChanges()
  }
 /**
  * The function logs the user out of the application and then navigates to the login page
  */
  public onLogout(){
    const bd= new PouchDB('maxsellglobal_mobile')
    bd.destroy()
    window.localStorage.removeItem('puntosSemilla')
      this.auth.auth.signOut().then(()=>{
        
          this.router.navigate(['/login']).then(()=>{
              window.location.reload()
          })
      })
  }

  /**Value TRM  */
  valorTRMFranja(franja){
      var trm=this.db.collection('preciosGlobales',ref=>ref.where('franja','==',franja))
      
      return trm
      
  }

  estadoPagos(){ 
    try{
      this.auth.auth.onAuthStateChanged(o=>{
        this.db.collection('usuarios',ref=>ref.where('role','==','3')).doc(o.uid).get().subscribe(l=>{
         if(l.data()['codigo_mantenimiento']==0){
            swal('Lo sentimos, no hemos recibido el pago por servicio de este mes','','warning').then(()=>{
              this.onLogout()
            })
          }
          if(l.data()['codigo_mantenimiento']==11){
            swal('El pago esta siendo procesado y verificado','gracias..','warning').then(()=>{
              this.onLogout()
            })
          }
          
        })
    
       })
    }catch(e){
      
    }
      
  }
  }
